import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { fetchTests } from './SiteOwnerTestResults.actions';
import { Action } from '@reduxjs/toolkit';
import {
  addTests,
  setIsFetching,
  setListTests,
  setPage,
  setTotal,
} from './SiteOwnerTestResults.slice';
import { RootState } from '../../app/store';
import { Unwrap } from '../../domains/app';
import ResultsService from '../../service/Results.service';

function* fetchTestsSaga(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchTests.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const page: number = yield select(
        (state: RootState) => state.siteownertestresults.page,
      );
      const pageSize: number = yield select(
        (state: RootState) => state.siteownertestresults.pageSize,
      );
      const search: string = yield select(
        (state: RootState) => state.siteownertestresults.search,
      );

      const res: Unwrap<ReturnType<
        typeof ResultsService.fetchListTestsForValid
      >> = yield call(
        ResultsService.fetchListTestsForValid,
        pageSize,
        page,
        search,
      );
      if (refreshList) {
        yield put(setListTests([]));
      }
      yield put(addTests(res.items));
      yield put(setTotal(res.total));
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([takeLatest(fetchTests.toString(), fetchTestsSaga)]);
}
